module.exports = __webpack_public_path__ + "img/sum.5bfe4180.svg";